export const DOCUMENT_STAGES = {
  draft: 'draft',
  finished: 'finished',
  inAcceptance: 'in_acceptance',
  inSign: 'in_sign',
  rejected: 'rejected',
  sent: 'sent',
} as const;
